export const DASHBOARD_MAIN_SCROLL_SELECTOR =
	'.dashboard-screen:not(.dashboard-screen--mobile) .dashboard-screen__main-scroll .simplebar-content-wrapper';
export const APP_MAIN_SCROLL_INNER_SELECTOR = '.app-main-scroll .simplebar-content-wrapper';
export const APP_MAIN_SCROLL_SELECTOR = '.app-main-scroll';
export const DASHBOARD_HOME_MOBILE_SCROLL_SELECTOR = '.dashboard-home-mobile-scroll';

/** 首页主区滚动容器（手机原生层 / 桌面 SimpleBar 内层） */
export function getDashboardMainScrollElement() {
	if (typeof document === 'undefined') return null;
	return (
		document.querySelector(DASHBOARD_HOME_MOBILE_SCROLL_SELECTOR) ??
		document.querySelector(DASHBOARD_MAIN_SCROLL_SELECTOR)
	);
}

/** 首页主区滚回顶部（手机 .dashboard-home-mobile-scroll / 桌面 SimpleBar 内层） */
export function scrollDashboardMainScrollToTop({ smooth = true } = {}) {
	if (typeof document === 'undefined') {
		return false;
	}

	const behavior = smooth ? 'smooth' : 'auto';
	const mobileEl = document.querySelector(DASHBOARD_HOME_MOBILE_SCROLL_SELECTOR);
	if (mobileEl) {
		mobileEl.scrollTo({ top: 0, behavior });
		document.body.classList.remove('dashboard-home-mobile-navbar-hidden');
		return true;
	}

	const desktopEl = document.querySelector(DASHBOARD_MAIN_SCROLL_SELECTOR);
	if (desktopEl) {
		desktopEl.scrollTo({ top: 0, behavior });
		return true;
	}

	return false;
}

/** 主内容区滚动容器（SimpleBar 内层 → 外层 → documentElement 回退） */
export function getAppMainScrollElement() {
	if (typeof document === 'undefined') return null;
	return (
		document.querySelector(APP_MAIN_SCROLL_INNER_SELECTOR) ??
		document.querySelector(APP_MAIN_SCROLL_SELECTOR) ??
		document.documentElement
	);
}

/** 仪表盘或通用主内容区 SimpleBar 内层（顶栏滚动监听等） */
export function getAppMainScrollInnerElement() {
	if (typeof document === 'undefined') return null;
	return document.querySelector(DASHBOARD_MAIN_SCROLL_SELECTOR) ?? document.querySelector(APP_MAIN_SCROLL_INNER_SELECTOR);
}

/** 通用主内容区滚回顶部（统计页等走 .app-main-scroll） */
export function scrollAppMainScrollToTop({ smooth = true } = {}) {
	if (typeof document === 'undefined') {
		return false;
	}
	const behavior = smooth ? 'smooth' : 'auto';
	const el = getAppMainScrollInnerElement() ?? getAppMainScrollElement();
	if (!el) return false;
	el.scrollTo({ top: 0, behavior });
	return true;
}
